import css from "styled-jsx/css";
import { MAX_DESKTOP_CONTENT_WIDTH, MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";

export const componentStyles = css`
  .base-layout-segment-component {
    box-sizing: content-box;

    .segment-content-container {
      &:not(.full-width) {
        max-width: ${MAX_DESKTOP_CONTENT_WIDTH + "px"};
      }

      margin: auto;
    }
  }

  @media (max-width: ${MAX_DESKTOP_CONTENT_WIDTH + "px"}) {
    .base-layout-segment-component {
      padding: 0 24px;
    }
  }
`;
